import React, {useContext} from "react";
import {CustomQuote} from "../components/common";
import PersonIcon from "@mui/icons-material/Person";
import {ContentContext} from "../ContentContext";
import {DynamicIcon} from "../helper/getIcon";

function About() {
    const data = useContext(ContentContext);

    return (
        <>
            <section className={"about-section"}>
                <CustomQuote icon={<PersonIcon />}>
                    <span dangerouslySetInnerHTML={{__html: data?.subpageAboutInfoText}} />
                </CustomQuote>
            </section>
            {data?.subpageAboutContent.map((item, index) => (
                <section key={index} className={"about-section"}>
                    <div className={"about-title"}>
                        <DynamicIcon iconLibrary={item?.iconLibrary} iconName={item?.iconName} />
                        <h2>{item?.title}</h2>
                    </div>
                    <div className={"about-text"}>
                        <span dangerouslySetInnerHTML={{__html: item?.description}} />
                    </div>
                </section>
            ))}
        </>
    );
}

export default About;
